import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  FacebookService,
  FinnService,
  JobService,
  PaymentService,
  UserService,
  Utils,
} from '../../../lib/services';
import { ContentService } from '../../../lib/services/contentService';
import { User } from '../../../lib/classes/user';
import { take } from 'rxjs/operators';
import * as fromRoot from '../../../reducers';

import { Store } from '@ngrx/store';
import { selectCurrentUser } from '../../../core/selectors/auth';
import { Subscription } from 'rxjs';
import { Role, Unit } from '../../../settings-module/models/unit';
import { ModalService } from '../../../lib/services/modal.service';
import { MatDialog } from '@angular/material';
import { JobBoard, JobSourcing, Provider } from '../../models/job-sourcing';
import {
  PostEquestBoard,
  SelectFinnBoard,
  UpdateJobSourcing,
} from '../../actions/job-sourcing.actions';
import { getJobSourcingState, getSelectedEquestDraft } from '../../reducers';
import { SelectedJobState } from '../../../jobs-module/reducers/jobs.reducer';
import { FinnFormComponent } from '../finn-form/finn-form.component';

@Component({
  selector: 'mj-job-boards',
  templateUrl: './job-boards.template.html',
  styleUrls: ['./job-boards.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobBoardsComponent implements OnInit, OnDestroy {
  @Input() jobState: SelectedJobState;
  @Input() jobSourcing: SelectedJobState;

  public user: User;
  public currentUnit: Unit;
  public sourcing: JobSourcing;
  private sourcing$: Subscription;
  private currentUser$: Subscription;
  private currentUnit$: Subscription;
  private isGodUser: boolean;

  constructor(
    public $u: Utils,
    public cs: ContentService,
    public dialog: MatDialog,
    private _jobService: JobService,
    private _finnService: FinnService,
    private _userService: UserService,
    private _facebookService: FacebookService,
    private _paymentService: PaymentService,
    private modalService: ModalService,
    private store: Store<fromRoot.State>
  ) {}

  ngOnInit() {
    this.currentUser$ = this.store.select(selectCurrentUser).subscribe(user => {
      if (user.currentUser) {
        this.user = user.currentUser;
      }
    });
    this.currentUnit$ = this.store
      .select(fromRoot.getSelectedUnit)
      .subscribe(unit => {
        if (unit) {
          this.currentUnit = unit;
          this.isGodUser = unit.role === Role.GOD;
        }
      });
    this.sourcing$ = this.store
      .select(getJobSourcingState)
      .subscribe(sourcing => {
        if (sourcing) {
          this.sourcing = sourcing.selectedJobSourcing;
        }
      });
  }

  ngOnDestroy(): void {
    if (this.currentUser$) {
      this.currentUser$.unsubscribe();
    }
    if (this.currentUnit$) {
      this.currentUnit$.unsubscribe();
    }
    if (this.sourcing$) {
      this.sourcing$.unsubscribe();
    }
  }

  public toggleSelectedBoard(board: JobBoard, shouldBeEnabled: boolean) {
    if (
      shouldBeEnabled &&
      board.job_board_specification.provider === Provider.FINN
    ) {
      this.configureBoard(board);
    } else {
      board.enabled = shouldBeEnabled;
      this.store.dispatch(
        new UpdateJobSourcing({ jobSourcing: this.sourcing })
      );
    }
  }

  public configureBoard(board: JobBoard) {
    const provider = board.job_board_specification.provider;
    if (provider === Provider.FINN || provider === Provider.FINN_WITH_SUPPORT) {
      this.store.dispatch(
        new SelectFinnBoard({
          board: board,
        })
      );
      this.dialog
        .open(FinnFormComponent, {
          minWidth: '80vw',
          minHeight: '80vh',
        })
        .afterClosed()
        .subscribe(result => {
          board.enabled = true;
          board.finn_ad = result;
          this.store.dispatch(
            new UpdateJobSourcing({ jobSourcing: this.sourcing })
          );
        });
    } else if (provider === Provider.EQUEST) {
      this.store.dispatch(
        new PostEquestBoard({
          jobId: this.sourcing.job_id,
          boardId: board.id,
        })
      );
      this.store
        .select(getSelectedEquestDraft)
        .pipe(take(1))
        .subscribe(equestDraft => {
          if (equestDraft) {
            window.open(equestDraft['_links']['board:select-form']['href']);
          }
        });
    }
  }

  openFinnAd(board: JobBoard) {
    window.open(board.finn_ad.ad_url);
  }

  canBeConfigured(board: JobBoard) {
    return (
      (this.isGodUser &&
        board.job_board_specification.provider ===
          Provider.FINN_WITH_SUPPORT) ||
      (board.job_board_specification.provider === Provider.FINN &&
        board.finn_ad &&
        board.finn_ad.ad_url)
    );
  }

  public trackByFn(index, item) {
    return index; // or item.id
  }
}
